
import {UIGamePlayerInformationLargestArmyController} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationLargestArmyController'
import {UIWGamePlayerInformationLargestArmyView} from './UIWGamePlayerInformationLargestArmyView'

export class UIWGamePlayerInformationLargestArmyController extends UIGamePlayerInformationLargestArmyController {
    protected initPlayerInformationLargestArmyViews() {
        this.playerInformationLargestArmyViews.forEach((view) => view.destroy())
        this.playerInformationLargestArmyViews = []

        for(const playerState of this.uiGameManager.gameState.players) {
            const newPlayerInformationLargestArmyView = new UIWGamePlayerInformationLargestArmyView(this.uiGameManager, playerState)
            this.playerInformationLargestArmyViews.push(newPlayerInformationLargestArmyView)
        }
    }
}
